<template>
  <span>
    <span class="downTime" v-if="!flag">
      <!-- <span class="time">{{ day }}</span>
      <span class="data">天</span> -->
      <span class="time">{{ H }}</span>
      <span class="data">：</span>
      <span class="time">{{ M }}</span>
      <span class="data">：</span>
      <span class="time">{{ S }}</span>
      <!-- <span class="data">秒</span> -->
    </span>
    <span v-else class="end">已截止</span>
  </span>
</template>

<script>
export default {
  name: "downTime",
  data() {
    return {
      time: "",
      day: "",
      H: "",
      M: "",
      S: "",
      flag: false,
      myendTime: "2021-8-15 11:36:00",
    };
  },
  mounted() {
    let time = setInterval(() => {
      if (this.flag == true) {
        clearInterval(time);
      }
      this.timeDown();
    }, 500);
  },
  props: {
    //   传一个时间戳过来用于倒计时
    endTime: {
      type: String,
      defualt: "2021-9-8 ",
    },
  },
  methods: {
    timeDown() {
      var geshi = /^\d{4}-\d{1,2}-\d{1,2}$/;
      // 时间格式过滤正对有的传了小时有的只传了天
      var endTime = null;
      if (this.endTime.search(geshi) != -1) {
        let myendTime = this.endTime + "  23:59:59";
        endTime = new Date(myendTime);
      } else {
        endTime = new Date(this.endTime);
      }
      // const endTime = new Date(this.myendTime);
      const nowTime = new Date();
      let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000);

      let d = parseInt(leftTime / (24 * 60 * 60));
      let h = this.formate(parseInt((leftTime / (60 * 60)) % 24));
      let m = this.formate(parseInt((leftTime / 60) % 60));
      let s = this.formate(parseInt(leftTime % 60));
      if (leftTime <= 0) {
        this.flag = true;
        this.$emit("time-end");
      }
      this.time = `${d}天${h}小时${m}分${s}秒`;
      this.day = d;
      this.H = h;
      this.M = m;
      this.S = s;

      if (leftTime < 0) {
        this.time = `0天0小时0分0秒`;
        this.day = 0;
        this.H = 0;
        this.M = 0;
        this.S = 0;
        return;
      }
    },
    formate(time) {
      if (time >= 10) {
        return time;
      } else {
        return `0${time}`;
      }
    },
  },
};
</script>

<style scoped>
</style>